const getCart = async () => {
  try {
    const cart = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    return await cart.json();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default getCart;
